
import { Box, Heading } from "@chakra-ui/react";
import { SessionState, TriviaCategory, TriviaClue, TriviaClueBonus } from "jparty-shared";

import { DebugCommand, handleDebugCommand } from "../../misc/debug-command";
import { formatDollarValueString } from "../../misc/client-utils";

interface CategoryBoxProps {
    triviaCategory: TriviaCategory,
    triviaClue: TriviaClue,
}

export default function CategoryBox({ triviaCategory, triviaClue }: CategoryBoxProps) {
    const isWagerBonus = (triviaClue.bonus === TriviaClueBonus.Wager) || (triviaClue.bonus === TriviaClueBonus.AllWager);

    let clueValueString = "";
    if (!isWagerBonus) {
        clueValueString = `for ${formatDollarValueString(triviaClue.value)}`;
    }

    return (
        <Box id={"category-box"} className={"box"} padding={"1em"} width={"fit-content"} minWidth={"25vw"} marginLeft={"auto"} marginRight={"auto"}
            onClick={() => handleDebugCommand(DebugCommand.UpdateSessionState, SessionState.PromptClueSelection)}>
            <Heading size={"lg"} fontFamily={"clue"}>{triviaCategory.name.toUpperCase()} {clueValueString}</Heading>

            <Heading size={"sm"} fontFamily={"clue"}>
                <i>from the year {triviaClue.year}</i>
            </Heading>
        </Box>
    )
}